var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass:
        "border border-gray-300 soli-round w-full h-auto flex flex-col py-1 relative",
      attrs: { fluid: "" },
    },
    [
      _vm.formattingEnabled &&
      _vm.showFormatMenu &&
      (_vm.channel !== "chat" || _vm.$vuetify.breakpoint.smAndUp)
        ? _c(
            "div",
            { staticClass: "flex gap-1" },
            _vm._l(_vm.formatMenu, function (item, idx) {
              return _c(
                "div",
                { key: idx },
                [
                  item.icon
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            small: "",
                            "input-value": _vm.editor?.isActive(item.name),
                            tabindex: "1",
                          },
                          on: {
                            click: function ($event) {
                              return item.apply()
                            },
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                color: _vm.editor?.isActive(item.name)
                                  ? "accent"
                                  : "dark",
                              },
                            },
                            [_vm._v(_vm._s(item.icon))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !item.icon
                    ? _c("v-divider", {
                        staticClass: "mx-2",
                        attrs: { vertical: "" },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("editor-content", {
        staticClass: "editor",
        class: { "mb-4": _vm.channel !== "chat" },
        attrs: { editor: _vm.editor },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex justify-between overflow-hidden" },
        [
          _vm.channel
            ? _c(
                "div",
                {
                  staticClass:
                    "flex justify-start gap-2 shrink custom-animate animate__animated animate__fadeIn",
                },
                [
                  _vm.channel == "chat"
                    ? _c(
                        "div",
                        { class: { "flex gap-2": !_vm.showFormatMenu } },
                        [
                          false
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "", color: "dark" },
                                },
                                [_c("v-icon", [_vm._v("add_circle_outline")])],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                color: "dark",
                                tabindex: "1",
                              },
                              on: {
                                click: function ($event) {
                                  ;[
                                    (_vm.showFormatMenu = !_vm.showFormatMenu),
                                    _vm.editor.commands.focus(),
                                  ]
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("text_format")])],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.channel !== "chat"
                    ? _c(
                        "v-menu",
                        {
                          attrs: { "offset-x": "", top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              small: "",
                                              elevation: "0",
                                              rounded: "",
                                              disabled: !!_vm.thread?.id,
                                              color: _vm.channelColors(
                                                _vm.channel
                                              ),
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(_vm.channel) +
                                                "\n                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.thread?.id
                                          ? _c("v-divider", {
                                              staticClass: "ml-2",
                                              attrs: {
                                                vertical: "",
                                                color: "white",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.thread?.id
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticClass: "ml-1",
                                                attrs: { right: "" },
                                              },
                                              [_vm._v("keyboard_arrow_down")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1810424478
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeChannel("sms")
                                    },
                                  },
                                },
                                [_c("v-list-item-title", [_vm._v("SMS")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeChannel("email")
                                    },
                                  },
                                },
                                [_c("v-list-item-title", [_vm._v("Email")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                {
                                  attrs: { disabled: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeChannel("voice")
                                    },
                                  },
                                },
                                [_c("v-list-item-title", [_vm._v("Voice")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.crmMode
                    ? _c(
                        "v-menu",
                        {
                          attrs: { "offset-x": "", top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            class: {
                                              "gradient-ai text-shadow-blue":
                                                !!_vm.message?.id,
                                            },
                                            attrs: {
                                              small: "",
                                              rounded: "",
                                              loading: _vm.olliebotLoading,
                                              disabled: !_vm.message?.id,
                                              elevation: "0",
                                              color: "warning",
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "text-shadow-blue",
                                            attrs: { small: "" },
                                          },
                                          [_vm._v("auto_awesome")]
                                        ),
                                        _vm._v(" "),
                                        _c("v-divider", {
                                          staticClass: "ml-2",
                                          attrs: {
                                            vertical: "",
                                            color: "white",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "ml-1",
                                            attrs: { right: "" },
                                          },
                                          [_vm._v("keyboard_arrow_down")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3477931678
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.askOlliebot("followUp")
                                    },
                                  },
                                },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Follow-up"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.askOlliebot("fileSearch")
                                    },
                                  },
                                },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Suggest Response"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.askOlliebot("findAvailability")
                                    },
                                  },
                                },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Find Availability"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ollieResponse
                    ? _c(
                        "div",
                        { staticClass: "flex gap-2 items-center ml-1" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "x-small": "",
                                icon: "",
                                outlined: "",
                                loading: _vm.sentimentLoading == "liked",
                                color: "success",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.reviewOlliebot("liked")
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { "x-small": "" } }, [
                                _vm._v("thumb_up"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "x-small": "",
                                icon: "",
                                outlined: "",
                                color: "error",
                                loading: _vm.sentimentLoading == "disliked",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.reviewOlliebot("disliked")
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { "x-small": "" } }, [
                                _vm._v("thumb_down"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.channel == "chat" &&
                  _vm.showFormatMenu &&
                  _vm.$vuetify.breakpoint.xs
                    ? _c(
                        "div",
                        { staticClass: "flex px-2 gap-1" },
                        _vm._l(_vm.formatMenu, function (item, idx) {
                          return _c(
                            "div",
                            { key: idx },
                            [
                              item.icon
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        "input-value": _vm.editor?.isActive(
                                          item.name
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return item.apply()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: _vm.editor?.isActive(
                                              item.name
                                            )
                                              ? "accent"
                                              : "dark",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.icon))]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !item.icon
                                ? _c("v-divider", {
                                    staticClass: "mx-2",
                                    attrs: { vertical: "" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.characterLimit &&
          _vm.editor &&
          _vm.channel &&
          (_vm.channel === "chat"
            ? !(_vm.showFormatMenu && _vm.$vuetify.breakpoint.xs)
            : true)
            ? _c(
                "div",
                {
                  staticClass:
                    "caption whitespace-nowrap my-auto mr-4 animate__animated animate__fadeIn",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.editor.storage.characterCount.characters()) +
                      " /\n            " +
                      _vm._s(_vm.characterLimit) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showMacros
            ? _c(
                "small",
                { staticClass: "my-auto primary--text pt-0.5 pr-1" },
                [_vm._v("+ Enter")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.hideSubmit
            ? _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    small: "",
                    color: _vm.valid ? "primary" : "dark",
                    disabled: !_vm.valid,
                    loading: _vm.processing,
                  },
                  on: {
                    modEnter: function ($event) {
                      return _vm.$log("enter")
                    },
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_c("v-icon", [_vm._v(_vm._s(_vm.icon))])],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }